import { createCustomer, createCustomerHead } from '@/ducks/customersReducer'
import { createNewCustomer } from '@/ducks/newCustomerReducer'
import { get, post } from '@/util/auth'

import { API_ROUTE_CUSTOMERS } from './apiRoutes'

export const getCustomersAPI = async () => {
  const response = await get(API_ROUTE_CUSTOMERS)

  return {
    customers: transformCustomersFromWS(response),
    customerHeads: transformCustomerHeadsFromWS(response),
  }
}

const transformCustomersFromWS = (customers: any) =>
  customers.map((customer: any) =>
    createCustomer({
      orgNumber: customer.org_no,
      vatNumber: customer.vat_no,
      customerHeadId: customer.customer_head_id,
      customerHeadName: customer.customer_head_name,
      numberOfEmployees: customer.number_of_employees,
      customerStatus: customer.status,
      whitelabelName: customer.whitelabel_name,
      ...customer,
    })
  )

const transformCustomerHeadsFromWS = (customers: any) => {
  const result = []
  const map = new Map()

  for (const customer of customers) {
    if (!map.has(customer.customer_head_id)) {
      map.set(customer.customer_head_id, true) // set any value to Map
      result.push(
        createCustomerHead({
          id: customer.customer_head_id,
          name: customer.customer_head_name,
        })
      )
    }
  }
  return result
}

export const postCustomerAPI = async (customer: any) => {
  const payload = transformCustomerForWS({
    ...customer,
  })

  const response = await post(API_ROUTE_CUSTOMERS, payload)

  return response
}

const transformCustomerForWS = (customer: any) =>
  createNewCustomer({
    ...customer,
  })
